import { Rating } from '@mui/material';
import { Rate } from '../../types/Rate';
import './Rate.css';

interface RateComponentProps {
  rate: Rate;
  textColor?: string;
  emptyStarBorderColor?: string;
}

const RateComponent = ({ rate, textColor, emptyStarBorderColor }: RateComponentProps) => {
  return (
    <div className="rate">
      <div className="rateValue" style={{ color: textColor }}>
        {rate.average.toFixed(1)}
      </div>
      <Rating
        name="read-only"
        value={rate.average}
        readOnly
        size="small"
        precision={0.1}
        sx={{
          '& .MuiRating-iconEmpty': {
            stroke: emptyStarBorderColor || 'grey'
          }
        }}
      />
      <div className="rateValue" style={{ color: textColor }}>
        ({rate.quantity})
      </div>
    </div>
  );
};

export default RateComponent;
